import { axiosApiInstance } from "../axios";
import type { FinanceDateRangeValue } from "./dates";
import type {
  FinanceCustomerDetailsResponse,
  FinanceCustomerFilters,
  FinanceCustomersResponse,
  FinanceIcpResponse,
} from "./customer-types";

export async function fetchFinanceCustomers(
  range: FinanceDateRangeValue,
  page = 1,
  search = "",
  filters: FinanceCustomerFilters,
): Promise<FinanceCustomersResponse> {
  const response = await axiosApiInstance.get<FinanceCustomersResponse>(
    "finance/customers",
    {
      params: {
        from: range.from,
        to: range.to,
        page,
        search: search || undefined,
        sort: filters.sort,
        direction: "desc",
        currency_ids: filters.currencyIds.length
          ? filters.currencyIds
          : undefined,
        profitability_statuses: filters.profitabilityStatuses.length
          ? filters.profitabilityStatuses
          : undefined,
        customer_activities: filters.customerActivities.length
          ? filters.customerActivities
          : undefined,
        class_ids: filters.classIds.length ? filters.classIds : undefined,
        category_ids: filters.categoryIds.length
          ? filters.categoryIds
          : undefined,
        product_ids: filters.productIds.length ? filters.productIds : undefined,
      },
    },
  );
  return response.data;
}

export async function fetchFinanceIcp(
  range: FinanceDateRangeValue,
): Promise<FinanceIcpResponse> {
  const response = await axiosApiInstance.get<FinanceIcpResponse>(
    "finance/customers/icp",
    { params: range },
  );
  return response.data;
}

export async function fetchFinanceCustomerDetails(
  customerId: number,
  range: FinanceDateRangeValue,
): Promise<FinanceCustomerDetailsResponse> {
  const response = await axiosApiInstance.get<FinanceCustomerDetailsResponse>(
    `finance/customers/${customerId}`,
    { params: range },
  );
  return response.data;
}
